import { Box, Grid2 } from '@mui/material'
import React from 'react'
import { SearchSection, UseSelectBoxFeild } from '../student/MyCourses'
import CustomDivider from '../../shared/utils/CustomDivider'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { FilterButton } from '../../shared/utils/IconButton'
import { Constants } from '../../shared/constants'
import SchedulesTable from './SchedulesTable'

const Schedules = () => {
  return (
    <Box>
      {/* <SearchSection /> */}
      <CustomDivider orientation='horizontal' />
      <NormalContainerWithHeader >
          <FilterButton src={Constants.customImages.FilterDark} />
          <Grid2 children size={4} >
            <UseSelectBoxFeild label="Course Category" />
          </Grid2>
          <Grid2 children size={3}>
            <UseSelectBoxFeild label="Course Status" />
          </Grid2>
      </NormalContainerWithHeader>
      <CustomDivider orientation='horizontal' />
      <SchedulesTable />
    </Box>
  )
}

export default Schedules